import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import BikefittingLayout from '@/components/layout/BikefittingLayout.vue'
import TheHeader from '@/components/layout/TheHeader.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'MainView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createBlock(BikefittingLayout, null, {
    header: _withCtx(() => [
      _createVNode(TheHeader)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_RouterView)
    ]),
    _: 1
  }))
}
}

})